import React, { useContext, useState } from "react";
import "./index.css";
import { AppContext } from "../../context/AppContext";

export default function StudentForm() {
  const { setModalShow } = useContext(AppContext);

  const [isSubmitForm, setFormSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    student_name: "",
    phone_number: "",
    email: "",
    state: "",
    education: "",
    otherEducation: "",
    course: "",
    agreed: false,
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};

    if (!formData.student_name.trim()) {
      errs.student_name = "Name is required";
    } else if (!/^[A-Za-z ]{3,}$/.test(formData.student_name.trim())) {
      errs.student_name = "Name should be at least 3 letters";
    }

    if (!formData.phone_number.trim()) {
      errs.phone_number = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone_number.trim())) {
      errs.phone_number = "Phone must be exactly 10 digits";
    }

    if (!formData.email.trim()) {
      errs.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email.trim())) {
      errs.email = "Invalid email format";
    }

    if (!formData.state) {
      errs.state = "Please select your state";
    }

    if (!formData.education) {
      errs.education = "Please select your education";
    }

    if (!formData.course) {
      errs.course = "Please select your course";
    }

    if (!formData.agreed) {
      errs.agreed = "You must agree to the terms";
    }

    setErrors(errs);

    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Remove error when user corrects the field
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validate();

    if (!isValid) {
      return;
    }

    setLoading(true);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbw8EQKJzfny_CkzR_wF-FzDIh3B5sgiJ8WGK847ljwE38QjaqtF2CXf3jXuj1MT03_y/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          mode: "no-cors",
        },
      );

      setFormData({
        student_name: "",
        phone_number: "",
        email: "",
        education: "",
        otherEducation: "",
        course: "",
        agreed: false,
        state: "",
      });

      setFormSubmit(true);
      setErrors({});
    } catch (err) {
      console.error("❌ Submission failed", err);
    } finally {
      setLoading(false);

      setTimeout(() => {
        setModalShow(false);
      }, 3000);
    }
  };

  return (
    <form className="student-form-card" onSubmit={handleSubmit}>
      {/* =========================================
          BRAND HEADER
      ========================================= */}

      <div className="student-form-brand">
        <img
          className="company-logo"
          src="https://iqteche.in/static/media/wl_client_images/2d65766bae1c490c9cec775f6cc83ea9.png"
          alt="IBIX Qodify Technologies"
        />

        <div className="brand-name-wrapper">
          <h1 className="nav-heading">
            <span className="nav-brand">IBIX Qodify</span>

            <span className="nav-tech-text">Technologies</span>
          </h1>
        </div>
      </div>

      {/* =========================================
          SUCCESS SCREEN
      ========================================= */}

      {isSubmitForm ? (
        <div className="form-success-screen">
          <div className="success-image-wrapper">
            <img
              src="https://iqteche.in/static/media/wl_client_images/b83582403ca14311ad1e09fe9df3ba66.png"
              alt="Form submitted successfully"
              className="thumb-icon"
            />
          </div>

          <div className="success-check">✓</div>

          <h3>Request Submitted Successfully!</h3>

          <p>
            Thank you for contacting IBIX Qodify.
            <br />
            Our Career Expert will contact you shortly.
          </p>
        </div>
      ) : (
        <div className="student-form-content">
          {/* =========================================
              FORM INTRO
          ========================================= */}

          <div className="form-intro">
            <span className="form-eyebrow">CAREER GUIDANCE</span>

            <h2>Talk to Our Career Expert</h2>

            <p>
              Share your details and our expert will help you choose the right
              technology path.
            </p>
          </div>

          {/* =========================================
              STUDENT NAME
          ========================================= */}

          <div className="form-field">
            <label htmlFor="student_name">Student Name</label>

            <div className="input-container">
              <span className="field-icon">👤</span>

              <input
                id="student_name"
                type="text"
                name="student_name"
                placeholder="Enter your full name"
                value={formData.student_name}
                onChange={handleChange}
                autoComplete="name"
              />
            </div>

            {errors.student_name && (
              <p className="field-error">{errors.student_name}</p>
            )}
          </div>

          {/* =========================================
              PHONE
          ========================================= */}

          <div className="form-field">
            <label htmlFor="phone_number">Phone Number</label>

            <div className="input-container">
              <span className="field-icon">📱</span>

              <input
                id="phone_number"
                type="tel"
                name="phone_number"
                placeholder="Enter 10-digit mobile number"
                value={formData.phone_number}
                onChange={handleChange}
                maxLength="10"
                inputMode="numeric"
                autoComplete="tel"
              />
            </div>

            {errors.phone_number && (
              <p className="field-error">{errors.phone_number}</p>
            )}
          </div>

          {/* =========================================
              EMAIL
          ========================================= */}

          <div className="form-field">
            <label htmlFor="email">Email Address</label>

            <div className="input-container">
              <span className="field-icon">✉</span>

              <input
                id="email"
                type="email"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
              />
            </div>

            {errors.email && <p className="field-error">{errors.email}</p>}
          </div>

          {/* =========================================
              STATE
          ========================================= */}

          <div className="form-field">
            <label htmlFor="state">Your State</label>

            <div className="input-container">
              <span className="field-icon">📍</span>

              <select
                id="state"
                name="state"
                value={formData.state}
                onChange={handleChange}
              >
                <option value="">Select your state</option>

                <option value="Andhra Pradesh">Andhra Pradesh</option>

                <option value="Telangana">Telangana</option>

                <option value="Karnataka">Karnataka</option>

                <option value="Kerala">Kerala</option>

                <option value="Tamilnadu">Tamilnadu</option>
              </select>
            </div>

            {errors.state && <p className="field-error">{errors.state}</p>}
          </div>

          {/* =========================================
              EDUCATION
          ========================================= */}

          <div className="form-field">
            <label htmlFor="education">Education</label>

            <div className="input-container">
              <span className="field-icon">🎓</span>

              <select
                id="education"
                name="education"
                value={formData.education}
                onChange={handleChange}
              >
                <option value="">Select your education</option>

                <option value="High School">High School</option>

                <option value="Degree">Degree</option>

                <option value="B.Tech">B.Tech</option>

                <option value="12th/Diploma">12th / Diploma</option>

                <option value="Other">Other</option>
              </select>
            </div>

            {errors.education && (
              <p className="field-error">{errors.education}</p>
            )}
          </div>

          {/* =========================================
              OTHER EDUCATION
          ========================================= */}

          {formData.education === "Other" && (
            <div className="form-field">
              <label htmlFor="otherEducation">Mention Education</label>

              <div className="input-container">
                <span className="field-icon">✎</span>

                <input
                  id="otherEducation"
                  type="text"
                  name="otherEducation"
                  placeholder="Enter your qualification"
                  value={formData.otherEducation}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}

          {/* =========================================
              COURSE
          ========================================= */}

          <div className="form-field">
            <label htmlFor="course">Course You're Interested In</label>

            <div className="input-container">
              <span className="field-icon">💻</span>

              <select
                id="course"
                name="course"
                value={formData.course}
                onChange={handleChange}
              >
                <option value="">Select a course</option>

                <option value="Full Stack">Full Stack</option>

                <option value="Data Science">Data Science</option>

                <option value="AI & ML">AI & ML</option>

                <option value="Cyber Security">Cyber Security</option>

                <option value="Tech Tools">Tech Tools</option>
              </select>
            </div>

            {errors.course && <p className="field-error">{errors.course}</p>}
          </div>

          {/* =========================================
              AGREEMENT
          ========================================= */}

          <div className="agreement-section">
            <label className="agreement-label">
              <input
                type="checkbox"
                name="agreed"
                checked={formData.agreed}
                onChange={handleChange}
              />

              <span className="custom-check">{formData.agreed && "✓"}</span>

              <span className="agreement-text">
                I confirm that the information provided is correct and agree to
                the Terms & Conditions.
              </span>
            </label>

            {errors.agreed && <p className="field-error">{errors.agreed}</p>}
          </div>

          {/* =========================================
              SUBMIT
          ========================================= */}

          <button
            type="submit"
            className="student-submit-btn"
            disabled={loading}
          >
            <span>{loading ? "Submitting Request..." : "Request a Call"}</span>

            {!loading && <span className="submit-arrow">→</span>}
          </button>

          <div className="form-trust-text">
            🔒 Your information is kept secure and used only for career
            guidance.
          </div>
        </div>
      )}
    </form>
  );
}
